import React from 'react';
import '../style/header.scss';
import LogoSrc from '../assets/icons/logotype.svg';
import TelegramIcon from '../assets/icons/icon_m_telegram.svg';
import MenuIcon from '../assets/icons/icon_m_menu.svg';

// Define props for the Header component
interface HeaderProps {
  onContactClick: () => void; // Function to be called when "НАПИСАТЬ" button is clicked
}

// ОЧЕНЬ ВАЖНО: Здесь мы деструктурируем onContactClick из props
function Header({ onContactClick }: HeaderProps) {
  return (
    <header className='header'>
      <div className="logo-container">
        <img src={LogoSrc} alt="Логотип" className="logotype"/>
      </div>
      
      <div className="mobile-buttons-container">
        <button
          className="telegram-button"
          onClick={() => window.location.href = 'https://t.me/copylobby'}
        >
          <img src={TelegramIcon} alt="Telegram" />
        </button>
        <button className="mobile-menu-button">
          <img src={MenuIcon} alt="Menu" />
        </button>
      </div>

      <div className="menu-container">
        <button className="menu-button body-m-medium">ПОРТФОЛИО</button>
        <button className="menu-button-disabled body-m-medium">УСЛУГИ</button>
        <button className="menu-button-disabled body-m-medium">КОНТАКТЫ</button>
        <button className="menu-button-disabled body-m-medium">О НАС</button>
        <button className="menu-button-disabled body-m-medium">БЛОГ</button>
      </div>

      {/* onClick handler uses the destructured onContactClick prop */}
      <button
        className="default-button-accent body-m-medium"
        onClick={onContactClick} 
      >
        НАПИСАТЬ
      </button>
    </header>
  );
};

export default Header;
